import request from '@/utils/request'

// 特来电-面值列表
export function tldFacePriceList(params) {
  return request({
    url: '/plat-web/tldCharge/facePriceList',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}

// 获取业务配置说明详情
export function busiDescDetail(type) {
  return request({
    url: '/plat-web/busiDescription/detail/' + type,
    method: 'post',
    isPlatWeb: true
  })
}

// 特来电-下单支付
export function tldToPay(params) {
  return request({
    url: '/plat-web/tldCharge/toPay',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}

// 特来电-订单详情
export function tldOrderDetail(params) {
  return request({
    url: '/plat-web/tldCharge/orderDetail',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}
